import { FC } from 'react';
import styled from 'styled-components';
import { Theme } from '../theme/index';

export type GradientVariation =
  | 'prod'
  | 'poc'
  | 'test'
  | 'live'
  | 'paused'
  | 'archived'
  | 'migration'
  | 'scheduled'
  | 'finished';

const getBackground = (variation: GradientVariation, theme: Theme) => {
  switch (variation) {
    case 'prod':
      return `${theme.vars.newColor.blue2} linear-gradient(90deg, ${theme.vars.newColor.blue2} 0%, ${theme.vars.newColor.blue3} 25.55%, ${theme.vars.newColor.red3} 61.68%, ${theme.vars.newColor.orange2} 100%)`;
    case 'poc':
      return theme.vars.newColor.gold2;
    case 'live':
      return theme.vars.newColor.green2;
    case 'test':
      return theme.vars.newColor.orange2;
    case 'migration':
      return theme.vars.newColor.blue1;
    case 'paused':
      return theme.vars.newColor.lightGS1;
    case 'archived':
      return theme.vars.newColor.darkGS2;
    case 'scheduled':
      return theme.vars.newColor.blue3;
    case 'finished':
      return theme.vars.newColor.purple2;
  }
};

const StyledGradientBar = styled.div<IProps>`
  background: ${({ theme, variation }) => getBackground(variation, theme)};
  height: 0.5rem;
  left: 0;
  overflow: hidden;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 100;
`;

export interface IProps {
  variation?: GradientVariation;
}

export const GradientBar: FC<IProps> = ({ variation = 'prod' }) => (
  <StyledGradientBar data-testid="GradientBar" variation={variation} />
);

export default GradientBar;
